export default "__VITE_ASSET__Bv_Im3as__"